import React from "react";
import { useRef, useState, useEffect } from "react";
import "./SecurityCapability.css";
import img1 from "../securityassets/img1.png";
import img2 from "../securityassets/img2.png";
import img3 from "../securityassets/img3.png";
import img4 from "../securityassets/img4.png";

const processCards = [
  {
    id: 1,
    img: img1,
    border: "1px solid #4D1ED3",
    bg: "#EAE8FF",
    title: "dApp Ideation",
    description:
      "Integrate security practices into CI/CD pipelines to ensure continuous protection throughout the software delivery lifecycle.",
  },
  {
    id: 2,
    img: img2,
    border: "1px solid #E8824F",
    bg: "#FDF4ED",
    title: "Technical Design",
    description:
      "Automate security scanning for code, containers, and infrastructure to detect vulnerabilities early.",
  },
  {
    id: 3,
    img: img3,
    border: "1px solid #F3799B",
    bg: "#FEEFF2",
    title: "Development & API Integration Layer",
    description:
      "Implement automated compliance checks aligned with enterprise and healthcare regulations.",
  },
  {
    id: 4,
    img: img4,
    border: "1px solid #559B4C",   
    bg: "#E9F5E7",
    title: "Technical Design",
    description:
      "Enforce secure access controls and least-privilege policies across environments.",
  },
  {
    id: 5,
    img: img1,
    border: "1px solid #003C82",
    bg: "#CEF3FF",
    title: "Technical Design",
    description:
      "Apply security best practices and configuration standards across cloud, container, and on-premises systems.",
  },
];

export default function SecurityCapability() {
  const scrollContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } =
        scrollContainerRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  useEffect(() => {
    checkScroll();
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
      return () => {
        container.removeEventListener("scroll", checkScroll);
        window.removeEventListener("resize", checkScroll);
      };
    }
  }, []);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 450;
      const newScrollLeft =
        direction === "left"
          ? scrollContainerRef.current.scrollLeft - scrollAmount
          : scrollContainerRef.current.scrollLeft + scrollAmount;

      scrollContainerRef.current.scrollTo({
        left: newScrollLeft,
        behavior: "smooth",
      });
    }
  };

  const getCardScrollWidth = () => {
    if (!scrollContainerRef.current) return 0;
    const card = scrollContainerRef.current.querySelector(".card");
    if (!card) return 0;

    const gap = 24;
    return card.offsetWidth + gap;
  };

  return (
    <div id="security-capability">
      <div className="top">
        <h2 className="heading">dApp Development Process We Follow</h2>
        <p className="subheading">
          We build reliable, scalable decentralized exchange apps with agile
          methods and DevOps for fast, robust delivery.{" "}
        </p>
      </div>

      <div className="slider-wrapper">
        {canScrollLeft && (
          <button
            onClick={() => scroll("left")}
            className="scroll-button scroll-button-left"
          >
            ←
          </button>
        )}

        <div
          ref={scrollContainerRef}
          className={`cards-container ${!canScrollLeft ? "padding-left" : ""} ${
            !canScrollRight ? "padding-right" : ""
          }`}
        >
          {processCards.map((card) => (
            <div
              key={card.id}
              className="card" 
              style={{ background: card.bg, border: card.border }}
            >
              <div className="card-container-main">
                <img src={card.img} alt={card.title} className="card-image" />
                <h2 className="card-title">{card.title}</h2>
                <p className="card-description">{card.description}</p>
              </div>
            </div>
          ))}
        </div>

        {canScrollRight && (
          <button
            onClick={() => scroll("right")}
            className="scroll-button scroll-button-right"
          >
            →
          </button>
        )}
      </div>
      <div className="custom-dots">
        {processCards.map((_, index) => (
          <button
            key={index}
            className={`dot ${
              index ===
              Math.round(
                (scrollContainerRef.current?.scrollLeft || 0) /
                  getCardScrollWidth(),
              )
                ? "active"
                : ""
            }`}
            onClick={() => {
              scrollContainerRef.current?.scrollTo({
                left: index * getCardScrollWidth(),
                behavior: "smooth",
              });
            }}
          />
        ))}
      </div>
    </div>
  );
}
